import React, { useState } from "react";
import { Button, Menu, MenuItem, ListItemIcon, ListItemText, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DescriptionIcon from "@mui/icons-material/Description";

const EXPORTS = [
  { key: "work-orders", label: "Work Orders CSV", endpoint: "/api/work-orders/export/csv", filename: "work-orders" },
  { key: "violations", label: "Violations CSV", endpoint: "/api/violations/export/csv", filename: "violations" },
  { key: "architectural", label: "Architectural Requests CSV", endpoint: "/api/architectural-requests/export/csv", filename: "architectural-requests" },
];

const ExportMenu = ({ variant = "light" }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [exportingKey, setExportingKey] = useState(null);

  const handleExport = async (item) => {
    setExportingKey(item.key);
    try {
      const token = localStorage.getItem("authToken") || "";
      const res = await fetch(`${window.location.origin}${item.endpoint}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`Export failed (${res.status})`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${item.filename}-${Date.now()}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setExportingKey(null);
      setAnchorEl(null);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        size={variant === "dark" ? "small" : "medium"}
        startIcon={<DownloadIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={variant === "dark" ? {
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 600,
          whiteSpace: "nowrap",
          borderColor: "rgba(255,255,255,0.35)",
          color: "#fff",
          "&:hover": { borderColor: "#fff", backgroundColor: "rgba(255,255,255,0.1)" },
        } : {
          borderRadius: "10px",
          textTransform: "none",
          fontWeight: 600,
          borderColor: "rgba(47,99,173,0.25)",
          color: "#2f63ad",
        }}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {EXPORTS.map((item) => (
          <MenuItem key={item.key} onClick={() => handleExport(item)} disabled={exportingKey === item.key}>
            <ListItemIcon>
              {exportingKey === item.key ? <CircularProgress size={18} /> : <DescriptionIcon fontSize="small" />}
            </ListItemIcon>
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ExportMenu;
